import factory from '../positions/asset-positions-factory';

import LoansPosition from './loans-position';
import LoansPositionDetails from './loans-position-details';

export default factory({
  assetCategory: 'loans',

  RowComponent: LoansPosition,
  ExpandedRowComponent: LoansPositionDetails,
});
